export function getOrderIconClasses(
  field: string | null | undefined,
  orderBy: string | null | undefined,
  asc: boolean,
): Record<string, boolean> {
  if (!field) {
    return {};
  }
  const isActive = orderBy === field;
  return {
    'fa-up-down': !isActive,
    'fa-arrow-up-long': isActive && !!asc,
    'fa-arrow-down-long': isActive && !asc,
  };
}

export function getCuiOrderIconClasses(
  field: string | null | undefined,
  orderBy: string | null | undefined,
  asc: boolean,
): Record<string, boolean> {
  if (!field) {
    return {};
  }
  const isActive = orderBy === field;
  return {
    'cui-sort-ascending': !isActive || (isActive && !!asc),
    'cui-sort-descending': isActive && !asc,
  };
}
